import React, { useState } from "react";
import s from "./PoolTerminationBanner.module.scss";

const STORAGE_KEY = "pool-termination-phase2-dismissed";

const PoolTerminationBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const handleAcknowledge = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {}
    setDismissed(true);
  };

  return (
    <div className={s.root}>
      <div className={s.content}>
        <h4 className={s.title}>
          Hiveon Pool closure
        </h4>

        <p className={s.listItem}>
          As previously announced across all Hiveon product platforms, the Hiveon mining pool has been officially shut down effective May 13, 2026.
        </p>
        <p className={s.listItem}>
          Please be assured that all outstanding rewards will be fully paid out to the addresses specified in your Flight Sheets. We are currently performing final balance verifications. While we cannot provide an exact payout date at this moment, the distribution process will begin shortly. No further action is required on your part.
        </p>
        <p className={s.listItem}>
          Thank you for mining with us.
        </p>

        <button className={s.button} onClick={handleAcknowledge}>
          Acknowledge
        </button>
      </div>
    </div>
  );
};

export default PoolTerminationBanner;
